import * as React from 'react';
import { withPlainLayout, LayoutProps } from '../../components/Layout';

import Helmet from 'react-helmet';
import styled from '../../styled-components';
import { LinkArrow } from '../../components/ui';
import { media } from '../../utilities';

const ThankYouPageContent = styled.div`
    background-color: ${({ theme }) => theme.colors.deepBlue.color};
    color: white;
    height: 100vh;
`;

const ThankYouPageMessage = styled.div`
    max-width: 320px;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: white;
    color: ${({ theme }) => theme.colors.deepBlue.color};
    padding: 3rem;
    h1 {
        font-size: ${({ theme }) => theme.fontNew.primary.size.level5.size};

        ${media.m`
            font-size: ${({ theme }) => theme.fontNew.primary.size.level4.size};
        `}
    }

    ${media.m`
        max-width: 400px;
    `}
`;

const ThankYouPage = (props: LayoutProps) => {
    return (
        <>
            <Helmet>
                <title>
                    The Wave Machine - A free digital product clinic to help you
                    turn ripples into waves.
                </title>
                <meta
                    name="description"
                    content="A fun and informal session where we’ll explore your
                goals and uncover the barriers that are getting in
                your way."
                />
            </Helmet>

            <ThankYouPageContent>
                <ThankYouPageMessage>
                    <h1>Thanks, we'll be in touch!</h1>

                    <LinkArrow
                        to="/the-wave-machine-digital-product-clinic"
                        color="deepBlue"
                        arrowColor="electricBlue"
                    >
                        Take me back
                    </LinkArrow>
                </ThankYouPageMessage>
            </ThankYouPageContent>
        </>
    );
};

export default withPlainLayout(ThankYouPage);
